<template>
  <div class="justify-center gallery">
    <CarouselWidget
      class="products-carousel-widget"
      :items="items"
      :items-to-show="itemsToShow"
      dots
      dots-inside
    >
      <template #item="{ item }">
        <img
          @click="active = item"
          class="pa-3 pa-md-3 cursor-pointer gallery-thumb"
          :class="{ 'gallery-thumb-active': active == item }"
          :src="item + '?resize=1&w=672'"
          width="100%"
        />
      </template>
    </CarouselWidget>
  </div>
</template>

<script>
import CarouselWidget from "../../components/widgets/CarouselWidget/Index.vue";

const _carouselSettings = {
  itemsToShow: {
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1,
    xl: 1,
  },
};

export default {
  props: {
    main: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    active: 0,
    ..._carouselSettings,
  }),
  computed: {
    smOnly() {
      return this.$vuetify.breakpoint.smOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.active = this.main;
  },
  components: {
    CarouselWidget,
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  display: grid;
  gap: 8px;
  grid-template-columns: 100%;

  &-img,
  &-thumb {
    aspect-ratio: 1;
    border-radius: 2px;
    -o-object-fit: contain;
    object-fit: contain;
  }

  &-thumbs {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;

    @media screen and (max-width: 960px) {
      grid-template-columns: repeat(auto-fit, 100px);
    }
  }
}

.products-carousel-widget::v-deep {
  > .position-relative {
    padding-left: 40px;
    padding-right: 40px;
  }

  .carousel-widget-nav--inside {
    left: 0;
    right: 0;
  }
}
</style>
